"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadButtons = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _ChangeTableViewButton = require("../ChangeTableViewButton");

var _stringHash = _interopRequireDefault(require("string-hash"));

var _Utils = _interopRequireDefault(require("../../utils/Utils"));

var _tabConsts = require("../../constants/tabConsts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DownloadButtons =
/*#__PURE__*/
function (_Component) {
  _inherits(DownloadButtons, _Component);

  function DownloadButtons() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DownloadButtons);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DownloadButtons)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      articleSize: undefined,
      displayModal: false
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (format) {
      var exportKey = _this.props.exportKey;
      var exportKeyHash = (0, _stringHash["default"])(exportKey + Date.now().toString()); // startDownload(DOWNLOAD_URLS.ORDER_DOWNLOAD, {
      //     exportKey: exportKeyHash
      // });

      _this.props.onClick(format, exportKeyHash);
    });

    _defineProperty(_assertThisInitialized(_this), "checkArticles", function () {
      var _this$props = _this.props,
          fullFilter = _this$props.fullFilter,
          total = _this$props.total;

      if (_this.props.tabType === _tabConsts.TAB_TYPE.DELAYED_FULL) {
        _this.setState({
          articleSize: undefined
        });

        _Utils["default"].checkArticlesCount(fullFilter).then(function (response) {
          if (response !== undefined) {
            var count = response.articleSize;

            _this.setState({
              articleSize: count
            });

            _this.checkArticleCount(count);
          }
        });
      } else {
        _this.setState({
          articleSize: total
        });

        _this.checkArticleCount(total);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeSwitchReturnDelivDate", function () {
      _this.props.toggleSwitchRetDelivDate();
    });

    _defineProperty(_assertThisInitialized(_this), "changeSwitchLocalCurrency", function () {
      _this.props.toggleSwitchLocalCurrency();
    });

    return _this;
  }

  _createClass(DownloadButtons, [{
    key: "checkArticleCount",
    value: function checkArticleCount(count) {
      if (count < 500) {
        this.onClick('csv');
      } else {
        this.setState({
          displayModal: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          translate = _this$props2.translate,
          showArticleReportCSVButton = _this$props2.showArticleReportCSVButton,
          columns = _this$props2.columns,
          tabType = _this$props2.tabType,
          loading = _this$props2.loading;

      var onClose = function onClose() {
        _this2.setState({
          displayModal: false
        });
      };

      var style = {
        overlay: {
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
          position: 'absolute',
          zIndex: 2
        },
        content: {
          top: '30%',
          left: 0,
          right: 0,
          bottom: 0,
          textAlign: 'center',
          width: '500px',
          height: '200px',
          margin: '0 auto',
          position: 'absolute',
          zIndex: 3
        }
      };

      var handleDownloadingDelayed = function handleDownloadingDelayed() {
        _this2.onClick('csv');

        _this2.setState({
          displayModal: false
        });
      };

      return _react["default"].createElement("div", null, this.state.displayModal && _react["default"].createElement("div", {
        style: style.overlay
      }, _react["default"].createElement("div", {
        style: style.content
      }, _react["default"].createElement("h1", null, "WARNING."), _react["default"].createElement("p", null, "The current selection will include ", _react["default"].createElement("b", null, this.state.articleSize), " articles. Since the current stock data has to be requested LIVE, this can take a few moments. We recommend applying table filters in order to keep the result set as small as possible. Proceed anyways?"), _react["default"].createElement(_antd.Button, {
        type: "primary",
        style: {
          'marginRight': '5px'
        },
        onClick: handleDownloadingDelayed
      }, "YES"), _react["default"].createElement(_antd.Button, {
        type: "danger",
        onClick: onClose
      }, "NO"))), _react["default"].createElement(_antd.Row, {
        type: "flex",
        justify: "end",
        className: "mb-3"
      }, this.props.showSwitchRetDelivDate && _react["default"].createElement("p", {
        style: {
          marginRight: '10px',
          marginTop: '6px'
        }
      }, 'Delivered returns only ', _react["default"].createElement(_antd.Switch, {
        size: "small",
        defaultChecked: true,
        onChange: this.changeSwitchReturnDelivDate
      })), this.props.showSwitchLocalCurrency && _react["default"].createElement("p", {
        style: {
          marginRight: '10px',
          marginTop: '6px'
        }
      }, translate('sales/dashboard/LocalCurrencySwitch') + ' ', _react["default"].createElement(_antd.Switch, {
        size: "small",
        defaultChecked: false,
        checked: this.props.localCurrencySwitches && this.props.localCurrencySwitches[this.props.exportKey],
        onChange: this.changeSwitchLocalCurrency
      })), columns && _react["default"].createElement(_ChangeTableViewButton.ChangeTableViewButton, {
        tabType: tabType,
        columns: columns
      }), showArticleReportCSVButton && _react["default"].createElement(_antd.Tooltip, {
        placement: "topLeft",
        title: translate('view/downloadArticleReport')
      }, _react["default"].createElement(_antd.Button, {
        disabled: loading,
        className: "download-report-button",
        style: {
          marginRight: '6px'
        },
        onClick: function onClick() {
          return _this2.checkArticles();
        }
      }, translate('view/downloadArticleReport'))), _react["default"].createElement(_antd.Tooltip, {
        placement: "topLeft",
        title: translate('view/downloadExcel')
      }, _react["default"].createElement(_antd.Button, {
        disabled: loading,
        type: "primary",
        className: "download-button",
        icon: "download",
        onClick: function onClick() {
          return _this2.onClick('excel');
        },
        style: {
          fontSize: '12px'
        }
      }, _react["default"].createElement("span", null, translate("filterForm/DownloadButton"))))));
    }
  }]);

  return DownloadButtons;
}(_react.Component);

exports.DownloadButtons = DownloadButtons;